module.exports = __webpack_public_path__ + "img/sad-tear.3f345ffd.svg";